import { Component } from '@angular/core';
import { Router, CanActivate,ActivatedRoute,Params  } from '@angular/router';
import { ApicTokenService } from 'src/app/Services/apic-token-service';
import { HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';



@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html'
})



export class NavBarComponent {
  flag: boolean;
  token:string;
  firstName;
  lastName;

  myApp=false;
  myDashdoard=false;
  apiLib=false;
  getStarted=false;
  support=false;

  constructor(  private route: ActivatedRoute,public router: Router,private restApi: ApicTokenService) {
      
    this.firstName= localStorage.getItem("firstName");
    
    this.lastName= localStorage.getItem("lastName");

     const pat= this.router.url;

     if(pat.includes('/dashboard')){
       this.myDashdoard=true;
     }
     if(pat.includes('/myapp')){
      this.myApp=true;
    }
    if(pat.includes('/apis')){
      this.apiLib=true;
    }
    if(pat.includes('/aetna/gettingstarted')){
      this.getStarted=true;
    }
    if(pat.includes('/aetna/support')){
      this.support=true;
    }
   
   
  

  } 


  gotToMyDashboard(){


    localStorage.setItem("is_cuurent_nav_aem","n");
    this.router.navigate(['/dashboard']);
  }

  gotToMyApplication(){


    localStorage.setItem("is_cuurent_nav_aem","n");
    this.router.navigate(['/myapp']);
  }

  gotToMyApis(){


    localStorage.setItem("is_cuurent_nav_aem","n");
    this.router.navigate(['/apisegregation']);
  }

  gotToGettingStarted(){


    localStorage.setItem("is_cuurent_nav_aem","y");
    this.router.navigate(['/aetna/gettingstarted']);
  }


  gotToSupport(){


    localStorage.setItem("is_cuurent_nav_aem","y");
    this.router.navigate(['/aetna/support']);
  }

  logout(){
    
    this.token=localStorage.getItem("devportal_apic_token");
   
    localStorage.clear();
    this.revokeToken(this.token);
    
   
    this.router.navigate(['/logout']);

   
  }


  revokeToken(token){

    const client_id=environment.getAmClientId();
    const tokeHint='access_token';
 
     const bdy = `token_type_hint=${tokeHint}&token=${token}`;

   //  console.log("to see body "+bdy)
     return this.restApi.revokeToken_PostRequest(bdy.toString()).subscribe((data: {}) => {
    
    
    },(error)=>{
     
      })

  }





}